<!-- <ng-content select="question .read-only"></ng-content> -->
<ng-content select="question"></ng-content>


// WEBPACK FOOTER //
// ./src/app/questions-manager/questions-manager.component.html